module.exports = require("../../../../lib").stronachgroup.first.racehorse360;
